import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import * as InboxActions from './inbox.actions';
import { APIService } from '../../services/api/api-service';
import { notificationMessages } from '@care-portals/data';

@Injectable()
export class InboxEffects {
  constructor(
    private actions$: Actions,
    private api: APIService,
    private router: Router,
    private notification: NzNotificationService
  ) { }

  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.loadMessages),
      switchMap(action =>
        this.api
          .getMessages(action.filters)
          .pipe(
            map(messages => InboxActions.loadMessagesSuccess({ messages })),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Unable to load messages.');
              return of(InboxActions.loadMessagesFailure({ error }));
            })
          )
      )
    )
  );

  getFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.getFile),
      switchMap(action =>
        this.api
          .getFile(action.fileName)
          .pipe(
            map(file => InboxActions.getFileSuccess({ file })),
            catchError(error => {
              // console.error('Error', error);
              // this.notification.error(
              //   'Error',
              //   'There was an error getting file data.'
              // );
              return of(InboxActions.getFileFailure({ error }));
            })
          )
      )
    )
  );

  uploadFiles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.uploadFiles),
      switchMap(action =>
        this.api.uploadFiles(action.files).pipe(
          map(files => InboxActions.uploadFilesSuccess({ files })),
          catchError(error =>
            of(InboxActions.uploadFilesFailure({ error }))
          )
        )
      )
    )
  );

  uploadFilesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.uploadFilesSuccess),
      tap(() => {
        this.notification.success('Success', 'Uploaded Successfully')
      })
    ),{dispatch: false}
  );

  uploadFilesFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.uploadFilesFailure),
      tap((error) => {
        console.error('Error', error);
        this.notification.error(
          notificationMessages.UploadingFilesFailed.title,
          notificationMessages.UploadingFilesFailed.message
        );
      })
    ),{dispatch: false}
  );


  getMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.getMessage),
      switchMap(action =>
        this.api
          .getMessage(action.id)
          .pipe(
            map(message => InboxActions.getMessageSuccess({ message })),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Error Get Message.');
              return of(InboxActions.getMessageFailure({ error }));
            })
          )
      )
    )
  );

  replyMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InboxActions.replyMessage),
      switchMap(action =>
        this.api.replyMessage(action.inboundDto).pipe(
          map(message => InboxActions.replyMessageSuccess({ message })),
          tap(() => {
            if (action.navigate) {
              this.notification.success(
                'Done for now',
                'We will get back to you shortly.',
                { nzDuration: 10000 }
              );
              this.router.navigateByUrl('/');
            }
          }),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'Error Inbound Message.');
            return of(InboxActions.replyMessageFailure({ error }));
          })
        )
      )
    )
  );
}
